module.exports = __webpack_public_path__ + "/img/loading-white.db26bb9bb7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/loading-white.svg
// module id = 1391
// module chunks = 0